import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

// import { addToCart, addToWishlist, addToCompare } from '../../../actions'
import ProductListItem from "./collectionProductItem";
import ProductListingLoader from '../../common/loading/productListing';


class ProductListing extends Component {



    render() {
        const { products, addToCart, symbol, addToCompare, loading, addToWishlistClicked } = this.props;
        
        // addToWishlist , error,
        if (loading) {
            return (
                // <div>
                //     <div className="product-wrapper-grid">
                //         <div className="container-fluid">
                //         <div className="loading-cls"></div>
                //         </div>
                //     </div>
                // </div>
                <ProductListingLoader />
            )
        }
        return (
            <div>
                <div className="product-wrapper-grid">
                    <div className="container-fluid">
                        {products.length > 0 ?
                            <InfiniteScroll
                                dataLength={this.props.limit} //This is important field to render the next data
                                next={this.props.fetchMoreItems}
                                hasMore={this.props.hasMoreItems}
                                // loader={<div className="loading-cls"></div>}
                                loader={<ProductListingLoader />}
                                endMessage={
                                    <p className="seen-cls seen-it-cls">
                                           <b>End of list !</b>
                                    </p>
                                }
                            >
                                <div className="row">
                                    {products.slice(0, this.props.limit).map((product, index) =>
                                        <div className={`${this.props.colSize === 3 ? 'col-xl-3 col-md-6 col-grid-box' : 'col-lg-' + this.props.colSize}`} key={index}>
                                            <ProductListItem product={product} symbol={symbol}
                                                onAddToCompareClicked={() => addToCompare(product)}
                                                onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                onAddToCartClicked={addToCart} key={index} />
                                        </div>)
                                    }
                                </div>
                            </InfiniteScroll>
                            :
                            <div className="row">
                                <div className="col-sm-12 text-center section-b-space mt-5 no-found" >
                                    {/* <img src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`} className="img-fluid mb-4" /> */}
                                    <h3>Sorry. Couldn't find the product you were looking For.</h3>
                                    <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    // products: getVisibleproducts(state.data, state.filters),
    symbol: state.data.symbol,
    products: state.collection.products,
    loading: state.collection.loading,
    error: state.collection.error,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    // addToCart: addToCart,
    // addToWishlist: addToWishlist,
    // addToCompare: addToCompare,
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(ProductListing);